/* global React */
import useAcl from '@platform/react/hook/useAcl'

const AclHOC = Component => ({ ref, ...props }) => {
  const [aclProps] = useAcl(props.events.acl, Component)
  return aclProps.hidden ? null : (<Component ref={ref} {...props} {...aclProps} />)
}

export default AclHOC
